import { Component } from '@angular/core';
import { GroupProductListBaseComponent } from '../group-product-list-base.component';

@Component({
  selector: 'app-group-product-list-desktop',
  templateUrl: './group-product-list-desktop.component.html',
  styleUrls: [
    '../../../pages/lists-pages-common-styles.scss',
    '../group-product-list-base.component.scss',
  ],
})
export class GroupProductListDesktopComponent extends GroupProductListBaseComponent {
  constructor() {
    super();
  }
}
